import { Chip } from "@mui/material";
import { ReferralPipelineStatus } from "../../interfaces";

export const REFERRAL_PIPELINE_STATUSES: ReferralPipelineStatus[] = [
  "referred",
  "appointment_scheduled",
  "in_progress",
  "completed",
  "unsuccessful",
  "follow_up_needed",
];

export const pipelineStatusLabels: { [key: string]: string } = {
  referred: "Referred",
  appointment_scheduled: "Appointment Scheduled",
  in_progress: "In Progress",
  completed: "Completed",
  unsuccessful: "Unsuccessful",
  follow_up_needed: "Follow-Up Needed",
};

export const pipelineStatusColors: { [key: string]: string } = {
  referred: "#3F51B5",
  appointment_scheduled: "#0288d1",
  in_progress: "#fdb814",
  completed: "#2e7d32",
  unsuccessful: "#d32f2f",
  follow_up_needed: "#9D2362",
};

export const isTerminalPipelineStatus = (status?: string) =>
  status === "completed" || status === "unsuccessful";

const ReferralStatusChip = ({
  status,
  size = "small",
}: {
  status?: string;
  size?: "small" | "medium";
}) => {
  const effective = status || "referred";
  const color = pipelineStatusColors[effective] || "#9e9e9e";
  return (
    <Chip
      label={pipelineStatusLabels[effective] || effective}
      size={size}
      sx={{
        backgroundColor: `${color}1f`,
        color: color,
        fontWeight: 600,
        borderRadius: "6px",
      }}
    />
  );
};

export default ReferralStatusChip;
